import DataTable from 'lib/DataTable';
import { useQuery } from '@tanstack/react-query';
import { videoQueries } from 'queries/videos';

export default function LikedVideos() {
    const { data: likedVideos = [], isPending, isError } = useQuery(videoQueries.liked());

    if (isPending) {
        return null;
    }

    if (isError) {
        return <p className="text-sm text-destructive">Couldn&apos;t load liked videos.</p>;
    }

    return (
        <DataTable
            columns={[
                {
                    name: 'Liked Videos',
                    id: 'title',
                    navigateOnClick: (row: any) => `/video/${row.id}`
                }
            ]}
            rows={likedVideos}
        />
    );
}
